type RegionType = "state" | "territory";

type USRegion = {
  abbr: string;
  label: string;
  type: RegionType;
};
const usRegionsRaw: USRegion[] = [
  { abbr: "AL", label: "Alabama", type: "state" },
  { abbr: "AK", label: "Alaska", type: "state" },
  { abbr: "AS", label: "American Samoa", type: "territory" },
  { abbr: "AZ", label: "Arizona", type: "state" },
  { abbr: "AR", label: "Arkansas", type: "state" },
  { abbr: "CA", label: "California", type: "state" },
  { abbr: "CO", label: "Colorado", type: "state" },
  { abbr: "CT", label: "Connecticut", type: "state" },
  { abbr: "DE", label: "Delaware", type: "state" },
  { abbr: "DC", label: "District Of Columbia", type: "state" },
  { abbr: "FM", label: "Federated States Of Micronesia", type: "territory" },
  { abbr: "FL", label: "Florida", type: "state" },
  { abbr: "GA", label: "Georgia", type: "state" },
  { abbr: "GU", label: "Guam", type: "territory" },
  { abbr: "HI", label: "Hawaii", type: "state" },
  { abbr: "ID", label: "Idaho", type: "state" },
  { abbr: "IL", label: "Illinois", type: "state" },
  { abbr: "IN", label: "Indiana", type: "state" },
  { abbr: "IA", label: "Iowa", type: "state" },
  { abbr: "KS", label: "Kansas", type: "state" },
  { abbr: "KY", label: "Kentucky", type: "state" },
  { abbr: "LA", label: "Louisiana", type: "state" },
  { abbr: "ME", label: "Maine", type: "state" },
  { abbr: "MH", label: "Marshall Islands", type: "territory" },
  { abbr: "MD", label: "Maryland", type: "state" },
  { abbr: "MA", label: "Massachusetts", type: "state" },
  { abbr: "MI", label: "Michigan", type: "state" },
  { abbr: "MN", label: "Minnesota", type: "state" },
  { abbr: "MS", label: "Mississippi", type: "state" },
  { abbr: "MO", label: "Missouri", type: "state" },
  { abbr: "MT", label: "Montana", type: "state" },
  { abbr: "NE", label: "Nebraska", type: "state" },
  { abbr: "NV", label: "Nevada", type: "state" },
  { abbr: "NH", label: "New Hampshire", type: "state" },
  { abbr: "NJ", label: "New Jersey", type: "state" },
  { abbr: "NM", label: "New Mexico", type: "state" },
  { abbr: "NY", label: "New York", type: "state" },
  { abbr: "NC", label: "North Carolina", type: "state" },
  { abbr: "ND", label: "North Dakota", type: "state" },
  { abbr: "MP", label: "Northern Mariana Islands", type: "territory" },
  { abbr: "OH", label: "Ohio", type: "state" },
  { abbr: "OK", label: "Oklahoma", type: "state" },
  { abbr: "OR", label: "Oregon", type: "state" },
  { abbr: "PW", label: "Palau", type: "territory" },
  { abbr: "PA", label: "Pennsylvania", type: "state" },
  { abbr: "PR", label: "Puerto Rico", type: "territory" },
  { abbr: "RI", label: "Rhode Island", type: "state" },
  { abbr: "SC", label: "South Carolina", type: "state" },
  { abbr: "SD", label: "South Dakota", type: "state" },
  { abbr: "TN", label: "Tennessee", type: "state" },
  { abbr: "TX", label: "Texas", type: "state" },
  { abbr: "UT", label: "Utah", type: "state" },
  { abbr: "VT", label: "Vermont", type: "state" },
  { abbr: "VI", label: "Virgin Islands", type: "territory" },
  { abbr: "VA", label: "Virginia", type: "state" },
  { abbr: "WA", label: "Washington", type: "state" },
  { abbr: "WV", label: "West Virginia", type: "state" },
  { abbr: "WI", label: "Wisconsin", type: "state" },
  { abbr: "WY", label: "Wyoming", type: "state" },
];

const mapLocalizedRegion = ({ abbr, label }: USRegion) => ({ abbr, label });
export const usStates = usRegionsRaw
  .filter(({ type }) => type === "state")
  .map(mapLocalizedRegion);
export const usTerritories = usRegionsRaw
  .filter(({ type }) => type === "territory")
  .map(mapLocalizedRegion);
export const usRegions = [...usStates, ...usTerritories];

export const locationOptions = usRegions.map(({ label, abbr }) => ({
  label,
  value: abbr,
}));
